import { Box, Button, Checkbox, FormControlLabel, Grid, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { Order } from "../../../Shared/GeneratedTypes";
import { Localizations } from "../../../Shared/sharedTypes";

interface propsType {
    next: () => void;
    isAccepted: boolean;
    order: Order;
    localizations: Localizations;
}
export default function Privacy({ order, next, isAccepted, localizations }: propsType) {
    const [agreed, updateAgreed] = useState<boolean>(isAccepted);
    return (
        <>
            <Grid item className="PhaseTopSection">
                <Box m={3}>
                    <Typography
                        dangerouslySetInnerHTML={{ __html: order.privacyPolicy || localizations.privacyPolicyNotSet }}
                    ></Typography>
                </Box>
            </Grid>
            <Grid item className="footer" alignContent="flex-start" justify="space-between" container direction="row">
                <FormControlLabel
                    control={
                        <Checkbox
                            name="agreedCheck"
                            checked={agreed}
                            disabled={agreed}
                            color="primary"
                            onChange={(e) => updateAgreed(e.target.checked)}
                        />
                    }
                    label={localizations.privacyPolicyAcknowledgement}
                />
                <Button
                    size="large"
                    variant="contained"
                    color="primary"
                    disabled={!agreed}
                    onClick={() => {
                        if (agreed) {
                            next();
                        }
                    }}
                >
                    {localizations.next}
                </Button>
            </Grid>
        </>
    );
}
